module.exports = __webpack_public_path__ + "static/gallery_07-dea7c6e1fb79301ec5a1fb8245e01752.jpg";